var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    role: "img",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFBFF9",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    transform: "translate(0.000000, 1.000000)",
    stroke: "#FF2AEC"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0.25,
    x: 6.625,
    y: 0.125,
    width: 10.75,
    height: 21.75,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0.125 C7.46446609,0.125 6.625,0.964466094 6.625,2 L6.625,20 C6.625,21.0355339 7.46446609,21.875 8.5,21.875 L15.5,21.875 C16.5355339,21.875 17.375,21.0355339 17.375,20 L17.375,2 C17.375,0.964466094 16.5355339,0.125 15.5,0.125 L8.5,0.125 Z",
    strokeWidth: 0.25,
    transform: "translate(12.000000, 11.000000) rotate(-270.000000) translate(-12.000000, -11.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,11 L23,11",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeDasharray: 1,
    transform: "translate(12.000000, 11.000000) rotate(-90.000000) translate(-12.000000, -11.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.978218914,11 L22.9782189,11",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeDasharray: 1,
    transform: "translate(11.978219, 11.000000) rotate(-180.000000) translate(-11.978219, -11.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.8492424,11 L26.8492424,11",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeDasharray: 1,
    transform: "translate(12.000000, 11.000000) rotate(-135.000000) translate(-12.000000, -11.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.8492424,11 L26.8492424,11",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeDasharray: 1,
    transform: "translate(12.000000, 11.000000) rotate(-45.000000) translate(-12.000000, -11.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.5,
    cx: 12,
    cy: 11,
    r: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.5,
    cx: 12,
    cy: 11,
    r: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 0.5,
    x: 3.25,
    y: 2.25,
    width: 17.5,
    height: 17.5,
    rx: 2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12.13525,18.512 C16.71175,18.512 20.7655,16.27775 23.26975,12.842 C20.7655,9.407 16.71175,7.17275 12.13525,7.17275 C7.558,7.17275 3.50425,9.407 1,12.842 C3.50425,16.27775 7.558,18.512 12.13525,18.512 Z M8.51125,7.66475 C7.6285,8.573 7.08475,9.812 7.08475,11.1785 C7.08475,13.96325 9.34225,16.22075 12.12775,16.22075 C14.9125,16.22075 17.17,13.96325 17.17,11.1785 C17.17,9.812 16.62625,8.573 15.7435,7.66475 M3.88675,19.628 L18.34,5 L3.88675,19.628 Z",
    stroke: "#3B3331",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/closeEye.8e09acb6c5ac2fef306905a92e0b0de4.svg";
export { ForwardRef as ReactComponent };